<template>
  <div class="page-content">
    <b-container class="mb-5">
      <b-row class="mt-5">
        <b-col>
          <h1>{{$t('myAccount.title')}}</h1>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="3">
          <p>
            <a class="content-link" href="#my-details">
              <span class="fa fa-user mr-2"></span>
              {{$t('myAccount.myDetails')}}
            </a>
          </p>
          <p>
            <a class="content-link" href="#your-team">
              <span class="fa fa-users mr-2"></span>
              {{$t('myAccount.yourTeam')}}
            </a>
          </p>
          <p>
            <a class="content-link" href="#account-settings">
              <span class="fa fa-cog mr-2"></span>
              {{$t('myAccount.accountSettings')}}
            </a>
          </p>
        </b-col>
        <b-col class="white-box">
          <b-row>
            <b-col>
              <h2 id="my-details">{{$t('myAccount.myDetails')}}</h2>
              <hr/>
              <account-details/>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <h2 id="your-team">{{$t('myAccount.yourTeam')}}</h2>
              <hr/>
              <b-row>
                <b-col>
                  <team-members/>
                </b-col>
                <b-col v-if="isUserAdmin">
                  <invite-user-form/>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <h2 id="account-settings">{{$t('myAccount.accountSettings')}}</h2>
              <hr/>
              <b-row>
                <b-col cols="6">
                  <change-password-form/>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import AccountDetails from '../components/account/AccountDetails.vue';
  import TeamMembers from '../components/account/TeamMembers.vue';
  import InviteUserForm from '../components/account/InviteUserForm.vue';
  import ChangePasswordForm from '../components/account/ChangePasswordForm.vue';

  export default {
    components: {
      AccountDetails,
      TeamMembers,
      InviteUserForm,
      ChangePasswordForm,
    },
    computed: mapGetters('account', ['isUserAdmin']),
  };
</script>

<style scoped>
  .white-box {
    background: white;
    border-radius: 4px;
    padding: 60px 40px;
  }

  .content-link {
    text-decoration: none !important;
    color: black;
  }
</style>
